import { RiskAssessmentTemplateResourceType } from "@components/shared/risk-assessment-templates/constants";

const { COUNTRY, DELIVERY, LOCATION, MATERIAL, ORGANISATION, PRODUCT } =
  RiskAssessmentTemplateResourceType;

export const relatedRiskAssessmentReportResourceTypesMap: Record<
  RiskAssessmentTemplateResourceType,
  RiskAssessmentTemplateResourceType[]
> = {
  [COUNTRY]: [],
  [DELIVERY]: [COUNTRY, ORGANISATION, LOCATION, MATERIAL, PRODUCT, DELIVERY],
  [LOCATION]: [COUNTRY, ORGANISATION],
  [MATERIAL]: [],
  [ORGANISATION]: [COUNTRY],
  [PRODUCT]: [COUNTRY, ORGANISATION, LOCATION, MATERIAL, PRODUCT],
};
